import { AxiosError } from 'axios';
import { call, put, take, all, fork, select } from 'redux-saga/effects';
import * as actions from '../actions';
import { apiMethods } from '../services/api';
import { apiMethodsConst } from '../services/methods';

type TApiMethodKey = keyof typeof apiMethods;

function* callAndDispatch(method: TApiMethodKey, payload?: any): Generator<any, any, any> {
  const response = yield call(apiMethods[method], payload);
  yield put({ type: method, payload: response });
}

function* watchtabChangeInbox(): Generator<any, void, any> {
  actions.createRequestTypes(actions.SELECT_CONTENT_TYPE_INBOX);
  while (true) {
    yield take(actions.SELECT_CONTENT_TYPE_INBOX);
  }
}

function* watchGetAllMessages(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.GET_USER_MESSAGES);
  while (true) {
    const { state }: { state: any } = yield take(actions.GET_USER_MESSAGES);

    try {
      yield select((store: any) => store.messages);
      if (JSON.stringify(state)) {
        yield put({ type: events.REQUEST, payload: state });

        yield* callAndDispatch(apiMethodsConst.GET_MESSAGES_REQUEST, state);

        yield put({
          type: events.SUCCESS,
        });
      }
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchGetMessagesByJob(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.GET_MESSAGES_BY_JOB_ID);
  while (true) {
    const { jobId }: { jobId: any } = yield take(actions.GET_MESSAGES_BY_JOB_ID);
    yield put({ type: events.REQUEST });
    try {
      const { job }: { job: any } = yield select((store: any) => store.job);

      if (job?.id !== jobId) {
        yield* callAndDispatch(apiMethodsConst.FETCH_JOB_REQUEST, jobId);
      }

      yield* callAndDispatch(apiMethodsConst.GET_MESSAGES_BY_JOB_ID_REQUEST, jobId);

      yield put({
        type: events.SUCCESS,
      });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchPostNewMessage(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.POST_NEW_MESSAGE);
  while (true) {
    const { jobId, message }: { jobId: any; message: any } = yield take(actions.POST_NEW_MESSAGE);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.POST_MESSAGE_REQUEST, { jobId, message });
      yield put({
        type: events.SUCCESS,
      });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

function* watchRequestAdmin(): Generator<any, void, any> {
  const events: any = actions.createRequestTypes(actions.REQUEST_ADMIN);
  while (true) {
    const { jobId }: { jobId: any } = yield take(actions.REQUEST_ADMIN);
    yield put({ type: events.REQUEST });
    try {
      yield* callAndDispatch(apiMethodsConst.INVITE_ADMIN_REQUEST, jobId);
      yield put({
        type: events.SUCCESS,
      });
    } catch (error) {
      yield put({ type: events.FAILURE, payload: (error as AxiosError)?.response?.data });
    }
  }
}

// use them in parallel
export default function* sagaMessages(): Generator<any, void, any> {
  yield all([
    fork(watchGetAllMessages),
    fork(watchGetMessagesByJob),
    fork(watchPostNewMessage),
    fork(watchRequestAdmin),
    fork(watchtabChangeInbox),
  ]);
}
